import React from 'react';

const HeaderLogo = () => {
  return (
    <span className="hdlogo" aria-hidden="true">
      <svg
        className="hdlogo-mark"
        width="42"
        height="42"
        viewBox="0 0 120 120"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="hdlogo-ring" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#C9A24B" />
            <stop offset="0.55" stopColor="#7C5CFC" />
            <stop offset="1" stopColor="#22D8F0" />
          </linearGradient>
        </defs>

        {/* outer ring */}
        <circle cx="60" cy="60" r="52" fill="none" stroke="url(#hdlogo-ring)" strokeWidth="2.4" opacity="0.9" />

        {/* left half: lotus petals (gold) */}
        <g stroke="#C9A24B" fill="none" strokeWidth="2.6" strokeLinejoin="round">
          <path d="M46 60 C 38 51, 27 51, 17 60 C 27 69, 38 69, 46 60 Z" />
          <path
            d="M46 60 C 38 51, 27 51, 17 60 C 27 69, 38 69, 46 60 Z"
            transform="rotate(-38 60 60)"
            opacity="0.85"
          />
          <path
            d="M46 60 C 38 51, 27 51, 17 60 C 27 69, 38 69, 46 60 Z"
            transform="rotate(38 60 60)"
            opacity="0.85"
          />
        </g>

        {/* right half: circuit traces (cyan) */}
        <g stroke="#22D8F0" strokeWidth="2.6" fill="none" strokeLinecap="round">
          <path d="M74 60 H 98" />
          <path d="M72.5 51 L 85 38.5 H 94" />
          <path d="M72.5 69 L 85 81.5 H 94" />
        </g>
        <circle cx="102.5" cy="60" r="3.8" fill="#22D8F0" />
        <circle cx="98.5" cy="38.5" r="3.2" fill="#22D8F0" opacity="0.92" />
        <circle cx="98.5" cy="81.5" r="3.2" fill="#22D8F0" opacity="0.92" />

        {/* nucleus */}
        <circle cx="60" cy="60" r="6.2" fill="#7C5CFC" />
        <circle cx="60" cy="60" r="11.4" fill="none" stroke="#7C5CFC" strokeWidth="1.4" opacity="0.45" />
      </svg>
    </span>
  );
};

export default HeaderLogo;
